import { decorate, observable, action } from "mobx"
import autoBind from "auto-bind"
import _ from 'lodash'


import {
  OPENAI_MODEL_VARIANTS,
  CHAT_SETTINGS_STORAGE_KEY
} from "../lib/constants";

class ChatSettingsStore {

  chatConfig = null;

  // These settings are used for development purpose
  // We use assistant config settings in production
  settings = {};

  apiEndpoints = {};

  modelsByTokens = null;

  constructor() {
    autoBind(this)
  }

  getChatSettings() {
    const settingsStr = localStorage.getItem(CHAT_SETTINGS_STORAGE_KEY);
    const _chatSettings = JSON.parse(settingsStr || null) || {};

    return _chatSettings;
  }

  setChatConfig(chatConfig) {
    this.chatConfig = chatConfig
  }

  getChatModel(modelVariantId) {
    return OPENAI_MODEL_VARIANTS.find(
      (variant) => variant.id === modelVariantId
    );
  }

  loadChatSettings(settings) {
    const localSettings = this.getChatSettings();
    const mergedSettings = _.merge(localSettings, settings);

    if (typeof mergedSettings.defaultOpenAIChatModelId !== 'undefined') {
      mergedSettings.baseChatModel = this.getChatModel(mergedSettings.defaultOpenAIChatModelId)
    }

    if (typeof mergedSettings.defaultModelIdForFunctionCall !== 'undefined') {
      mergedSettings.baseChatModelForFunctionCall = this.getChatModel(mergedSettings.defaultModelIdForFunctionCall)
    }

    this.settings = mergedSettings
  }

  updateChatSettings(newSettings) {
    for (const key in newSettings) {
      this.settings[key] = newSettings
    }
  }

  saveChatSettings(settings = {}) {
    localStorage.setItem(CHAT_SETTINGS_STORAGE_KEY, JSON.stringify(_.omit(settings, ['visible'])))
  }

  setModelsByTokens(modelsByTokens) {
    this.modelsByTokens = modelsByTokens
  }

  setApiEndpoints(apiEndpoints) {
    this.apiEndpoints = apiEndpoints
  }

  updateAPiEndpoints(apiEndpoints) {
    this.apiEndpoints = { ...this.apiEndpoints, ...apiEndpoints }
  }
}

decorate(ChatSettingsStore, {
  chatConfig: observable,
  settings: observable,
  modelsByTokens: observable,
  apiEndpoints: observable,

  setChatConfig: action,
  getChatSettings: action,
  updateChatSettings: action,
  loadChatSettings: action,
  saveChatSettings: action,

  setApiEndpoints: action,
  updateAPiEndpoints: action,

  setModelsByTokens: action
})

export default ChatSettingsStore;